module.exports = __webpack_public_path__ + "static/media/Roast_Garlic.c3a71224.webp";